import { z } from 'zod'

import { trainerProperties } from './BaseModels'
import cachedDummies from './cachedDummies'
import parseModel from './parseModel'

export const trainerParser = z.object({
  ...trainerProperties,
})

export type Trainer = z.infer<typeof trainerParser>

export const dummyTrainer = cachedDummies(
  (uuid: string, error?: any): Trainer => ({
    isDummy: true,
    error,
    uuid,

    clientUuid: null,

    createdAt: new Date(),

    firstname: 'Berta',
    lastname: 'Brot',
  })
)

export const parseTrainer = parseModel<Trainer>(trainerParser, dummyTrainer)
